document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("contact-form-modal");
  if (!modal) return;

  var openButtons = document.querySelectorAll(
    '[data-bs-toggle="modal"][data-bs-target="#contact-form-modal"]'
  );
  var closeButtons = modal.querySelectorAll(".js-fl-modal-close");
  var overlay = modal.querySelector(".fl-modal-overlay");

  function openModal(e) {
    if (e && e.preventDefault) e.preventDefault();
    overlay.classList.add("is-visible");
    document.body.classList.add("fl-modal-open");
  }

  // Check if we need to auto-open (after submission)
  // We look for the data-attribute directly in the modal
  if (modal.querySelector('[data-modal-open-status="true"]')) {
      openModal();
  }

  function closeModal() {
    overlay.classList.remove("is-visible");
    document.body.classList.remove("fl-modal-open");
  }

  // Bind Open Buttons
  openButtons.forEach(function (btn) {
    btn.addEventListener("click", openModal);
  });

  // Bind Close Buttons
  closeButtons.forEach(function (btn) {
    btn.addEventListener("click", closeModal);
  });

  // Close when clicking outside content (overlay)
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) {
      closeModal();
    }
  });

  // Close on Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-visible")) {
      closeModal();
    }
  });
});
